<template lang="pug">
  #common-public
    .header
      img(v-if="logo" :src="logo | staticPath" alt="Logo")
      h1(v-if="titleKey") {{ $t(titleKey) }}
      .clearAll
      hr
    slot
</template>

<script>
import config from '@/utils/config'

export default {
  name: 'CommonPublic',
  props: {
    titleKey: { type: String, required: false }
  },
  computed: {
    logo: {
      get () {
        if (!config.logo) return null
        return `/static/img/${config.logo}`
      }
    }
  }
}
</script>